module.exports = __webpack_public_path__ + "static/media/astronauts.0d2ff286.svg";